import React, { useEffect, useState } from "react";
import { AgCharts } from "ag-charts-react";
import "ag-charts-enterprise";
import {
  AgBarSeriesOptions,
  AgCategoryAxisOptions,
  AgChartCaptionOptions,
  AgChartLegendOptions,
  AgChartOptions,
  AgChartSubtitleOptions,
  AgNumberAxisOptions,
} from "ag-charts-enterprise";
import { useTheme } from "next-themes";

const FirstLoad = () => {
  const { theme } = useTheme();

  const [options, setOptions] = useState<AgChartOptions>({
    // Chart Title
    theme: "ag-default",
    title: { text: "Monthly Risk Exposure" } as AgChartCaptionOptions,
    // Chart Subtitle
    subtitle: { text: "Data from 2024" } as AgChartSubtitleOptions,
    // Data: Data to be displayed within the chart
    data: [],
    // Series: Defines which chart type and data to use
    series: [
      {
        type: "bar",
        xKey: "month",
        yKey: "y",
        yName: "y",
      } as AgBarSeriesOptions,
    ],
    background: {
      visible: false,
    },
    // Axes: Configure the axes for the chart
    axes: [
      // Display category (xKey) as the bottom axis
      {
        type: "category",
        position: "bottom",
      } as AgCategoryAxisOptions,
      // Use left axis for 'iceCreamSales' series
      {
        type: "number",
        position: "left",
        keys: ["y"],
        // Format the label applied to this axis
        label: {
          formatter: (params) => {
            return parseFloat(params.value).toLocaleString();
          },
        },
      } as AgNumberAxisOptions,
    ],
    // Legend: Matches visual elements to their corresponding series or data categories.
    legend: {
      position: "right",
    } as AgChartLegendOptions,
  });

  useEffect(() => {
    if (theme == "dark") {
      setOptions({ ...options, theme: "ag-default-dark" });
    } else {
      setOptions({ ...options, theme: "ag-default" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return (
    <div className="layout-container h-full w-full">
      <AgCharts
        className={`h-full w-full ${theme == "dark" ? "ag-default-dark" : "ag-default"}`}
        options={options}
      />
    </div>
  );
};

export default FirstLoad;
